const CCategoryOwnership = {
  PUBLIC: 'public',
  PRIVATE: 'private'
};

export { CCategoryOwnership };
